var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M12.475 11l8.934-8.934c.407-.407.407-1.068 0-1.475-.408-.407-1.068-.407-1.476 0L11 9.525 2.067.591C1.659.184.999.184.59.591.184.998.184 1.66.591 2.066L9.525 11 .59 19.934c-.407.407-.407 1.068 0 1.475.204.203.47.305.738.305.267 0 .534-.102.738-.305L11 12.475l8.933 8.934c.204.203.471.305.738.305s.534-.102.738-.305c.407-.407.407-1.068 0-1.475L12.475 11z","opacity":".8"}));
}

Cancel.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Cancel;

Cancel.default = Cancel;
